import { mapGetters } from 'vuex';

import {
  CompanyActivityStateType,
  RoleTypes,
  CompanyType,
} from '@/static/enums';

export const global = {
  data() {
    return {
      debounceTimer: null,
    };
  },
  computed: {
    ...mapGetters({
      resource: 'getResourceList',
      currentLang: 'getCurrentLang',
      currentUser: 'getCurrentUser',
      siriusCompanyContract: 'getCompanyContract',
      publishableKey: 'getPublishableKey',
      globalShowPricingButton: 'getShowPricingButton',
    }),
    isCompanyAdvanceOrPro() {
      const { segmentId } = this.currentUser;
      return segmentId === 2 || segmentId === 3;
    },
    isCompanyAdvance() {
      return this.currentUser.segmentId === 3;
    },
    isCompanyBasic() {
      return this.currentUser.segmentId === 1;
    },
    isCompanyPro() {
      return this.currentUser.segmentId === 2;
    },
    isCompanyWelcome() {
      return this.currentUser.companyType === CompanyType.welcome.id;
    },
    isUserAdminOrCRM() {
      const { companyUserRoleId, isCrmUser } = this.currentUser;
      return companyUserRoleId === RoleTypes.admin.id || isCrmUser;
    },
    isCompanyPassive() {
      return (
        CompanyActivityStateType[this.currentUser.companyActivityState]
          === 'CompanyPassiveMode'
        || CompanyActivityStateType[this.currentUser.companyActivityState]
          === 'CompanyRestrictedMode'
      );
    },
    isComingFromApplication() {
      return this.$route.query.ref === 'job-details';
    },
    isTemporaryUser() {
      return this.currentUser.companyUserRoleId === RoleTypes.temporaryUser.id;
    },
    isConsultantFirm() {
      const { isShowJobCard } = this.currentUser;
      return isShowJobCard;
    },
    hasExplicitConsentModuleRight() {
      return !this.currentUser.nonAuthorizedPermissions.some(
        (item) => item === 'kvkk.explicitconsenttext.right',
      );
    },
    hasExplicitConsentModuleTestMode() {
      const isExist = this.currentUser.nonAuthorizedPermissions.filter(
        (item) => item === 'kvkk.explicitconsenttext.usable',
      );

      return !(isExist && isExist.length > 0);
    },
    userSavedLastPath() {
      return localStorage.getItem('lastPath');
    },
    getCurrentAdTab() {
      return this.$route.fullPath.split('/')[2];
    },
    isResumeDetail() {
      return this.$route.name === 'ResumeDetailsView';
    },
    getSocketUrl() {
      return `${process.env.VUE_APP_SOCKET_URL}?userId=${this.currentUser.companyUserId}&groupId=${this.currentUser.companyId}`;
    },
  },
  methods: {
    setUserGuidingSegment() {
      const { companyUserRoleId } = this.currentUser;
      if (window.userGuiding) window.userGuiding.identify(companyUserRoleId.toString());
    },
    isObjectEmpty(obj) {
      return Object.entries(obj).length === 0;
    },
    getFormatedDateFromNow(date) {
      if (!date) {
        return '';
      }
      let formatedDate = null;
      const dateTime = this.$moment(new Date(new Date(date).toDateString()));
      const diffFromNow = this.$moment(
        new Date(new Date().toDateString()),
      ).diff(dateTime, 'days');

      switch (diffFromNow) {
        case 0:
          formatedDate = this.currentLang === 'tr-TR' ? 'Bugün' : 'Today';
          break;
        case 1:
          formatedDate = this.currentLang === 'tr-TR' ? 'Dün' : 'Yesterday';
          break;
        default:
          formatedDate = dateTime.format('DD.MM.YYYY');
          break;
      }
      return formatedDate;
    },

    globalFormatTimeUserLocal(date, format = 'DD MMMM YYYY, HH:mm') {
      const utcTime = this.$moment.utc(date);
      const localTime = utcTime.local();

      return localTime.format(format);
    },

    globalFormatTimeUserLocalWithLang(date, language = 'en') {
      const utcTime = this.$moment.utc(date);
      const localTime = utcTime.local();
      localTime.locale(language);

      return localTime.format('DD MMMM YYYY, HH:mm');
    },

    getDividerDateFromNow(date) {
      if (!date) return '';
      date = new Date(date);
      let dateTime = `${this.$moment(date, 'YYYYMMDD').fromNow()}`;
      const inSecond = dateTime.indexOf('saniye');
      const inHour = dateTime.indexOf('saat');
      const inMinute = dateTime.indexOf('dakika');

      if (inHour > -1 || inMinute > -1 || inSecond > -1) {
        dateTime = this.currentLang === 'tr-TR' ? 'Son 24 saat' : 'Last 24 hours';
      } else {
        dateTime = this.$moment(date).format('DD.MM.YYYY');
      }

      let dateTimeStr = '';
      if (this.currentDate !== dateTime) {
        this.currentDate = dateTime;
        dateTimeStr = dateTime;
      }
      return dateTimeStr;
    },

    compareArray(arr1, arr2) {
      if (!arr1 || !arr2) return;
      let result;
      arr1.forEach((e1) => arr2.forEach((e2) => {
        if (e1.length > 1 && e2.length) {
          result = this.compareArray(e1, e2);
        } else result = e1 === e2;
      }));
      return result;
    },

    compareObject(obj1, obj2) {
      return JSON.stringify(obj1) === JSON.stringify(obj2);
    },

    gsmFormatter(gsm) {
      const parts = gsm.match(/^\(?(\d{3})\D*(\d{3})\D*(\d{2})\D*(\d{2})$/);
      // format: 0(***) *** ** **
      return `0(${parts[1]}) ${parts[2]} ${parts[3]} ${parts[4]}`;
    },

    generateUuid() {
      /* eslint-disable */
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16),
      );
    },
    isInputNumber(event) {
      const keyCode = event.keyCode;
      if (keyCode < 48 || keyCode > 57) {
        event.preventDefault();
      }
    },
    filterMaximumInput(limit, limitCount) {
      if (limit > limitCount) {
        return limit.substring(0, limit.length - 1);
      }
      return limit;
    },
    debounceMethod(fn, delay = 500) {
      return ((...args) => {
        clearTimeout(this.debounceTimer);
        this.debounceTimer = setTimeout(() => {
          this.debounceTimer = null;
          fn(...args);
        }, delay);
      })();
    },
    filterDeletedUsers(users) {
      return users.filter((user) => user.status !== 2);
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const { resource } = vm.$route.meta;

      if (resource && vm.resource[resource])
        document.title = `${vm.resource[resource]}`;
      else document.title = 'interview.co';
    });
  },
};
